import { render, staticRenderFns } from "./AcordosList.vue?vue&type=template&id=bcbc3664"
import script from "./AcordosList.vue?vue&type=script&lang=js"
export * from "./AcordosList.vue?vue&type=script&lang=js"
import style0 from "./AcordosList.vue?vue&type=style&index=0&id=bcbc3664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports